module.exports = __webpack_public_path__ + "static/media/artunity-curator-show-userflow.1edf761a.jpg";